import api from "./Api";

class TributaAIService {
  getEmpresas() {
    return api.get("/v1/Gestao/TributaAI/Empresas").then((r) => r.data);
  }
  getEmpresasOData(payload) {
    return api.get("/OData/TributaAIEmpresa" + payload).then((r) => {
      if (Array.isArray(r.data)) {
        return {
          "@odata.count": r.data.length,
          value: r.data,
        };
      }
      return r.data;
    });
  }
  getEmpresasDisponiveis() {
    return api
      .get("/v1/Gestao/TributaAI/Empresas/Disponiveis")
      .then((r) => r.data);
  }
  getQuantidadeProdutos(id) {
    return api
      .get(`/v1/Gestao/TributaAI/Empresas/${id}/QuantidadeProdutos`)
      .then((r) => r.data);
  }
  adicionarEmpresa(payload) {
    return api
      .post("/v1/Gestao/TributaAI/Empresas", payload)
      .then((r) => r.data);
  }
  calcularOrcamento(payload) {
    return api
      .post("/v1/Gestao/TributaAI/Orcamentos/Calcular", payload)
      .then((r) => r.data);
  }
  salvarContrato(payload) {
    return api
      .post("/v1/Gestao/TributaAI/Contratos", payload)
      .then((r) => r.data);
  }
  bloquear(id, payload) {
    return api
      .post(`/v1/Gestao/TributaAI/Empresas/${id}/Bloquear`, payload)
      .then((r) => r.data);
  }
  desbloquear(id, payload) {
    return api
      .post(`/v1/Gestao/TributaAI/Empresas/${id}/Desbloquear`, payload)
      .then((r) => r.data);
  }
  getConsumo(id) {
    return api
      .get(`/v1/Gestao/TributaAI/Empresas/${id}/Consumo`)
      .then((r) => r.data);
  }
  getHabilitado() {
    return api.get("/v1/TributaAI/Habilitado").then((r) => r.data);
  }
  getSnapshotsOData(payload) {
    return api.get("/OData/TributaAISnapshot" + payload).then((r) => {
      if (Array.isArray(r.data)) {
        return {
          "@odata.count": r.data.length,
          value: r.data,
        };
      }
      return r.data;
    });
  }
  getSnapshots() {
    return api.get("/v1/TributaAI/Snapshots").then((r) => r.data);
  }
  getSnapshot(id, params) {
    return api
      .get(`/v1/TributaAI/Snapshots/${id}`, { params })
      .then((r) => r.data);
  }
  getHistoricoProduto(productId) {
    return api
      .get(`/v1/TributaAI/Produtos/${productId}/Historico`)
      .then((r) => r.data);
  }
  removerSnapshot(id) {
    return api.delete(`/v1/TributaAI/Snapshots/${id}`).then((r) => r.data);
  }
  criarSnapshot(payload) {
    return api.post("/v1/TributaAI/Snapshots", payload).then((r) => r.data);
  }
  reconsultarSnapshot(id) {
    return api
      .post(`/v1/TributaAI/Snapshots/${id}/Reconsultar`)
      .then((r) => r.data);
  }
  reconsultarItem(id, itemId) {
    return api
      .post(`/v1/TributaAI/Snapshots/${id}/Itens/${itemId}/Reconsultar`)
      .then((r) => r.data);
  }
  aplicar(id, payload) {
    return api
      .post(`/v1/TributaAI/Snapshots/${id}/Aplicar`, payload)
      .then((r) => r.data);
  }
  revisar(id, itemId, payload) {
    return api
      .post(`/v1/TributaAI/Snapshots/${id}/Itens/${itemId}/Revisar`, payload)
      .then((r) => r.data);
  }
}

export default new TributaAIService();
